import {
    OnInit,
    Component,
    HostBinding,
    Input,
    ChangeDetectionStrategy,
} from '@angular/core';

import { Resolutions } from '@core/domain/state/core.state';
import { ContentItemTree } from '@features/cms-render/domain/models/contentItemTree';

@Component({
    selector: 'piece-button',
    templateUrl: './piece-button.component.html',
    styleUrls: ['./piece-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PieceButtonComponent implements OnInit {
    @Input() public element: ContentItemTree;

    @Input() public direction: string;

    @Input() public resolution: Resolutions;

    @HostBinding('class') public aligmentClasses: string | undefined;

    public style: Record<string, string> = {
        '--background-color': '',
        '--border-radius': '',
        '--hover-background-color': '',
        '--hover-color': '',
        '--pressed-color': '',
        '--pressed-background-color': '',
        '--image-to-text-position': 'up',
        '--border': '',
    };

    public ngOnInit(): void {
        if (!!this.element.settings) this.fillButtonStyles();
    }

    private fillButtonStyles(): void {
        const buttonStyles = this.element.settings.general.buttonStyles;

        if (this.element) {
            this.aligmentClasses = this.getWysiwygAligmentClasses(this.element);
        }
        const border = `${this.element.settings.styles.borderWidth} ${this.element.settings.styles.borderStyle} ${this.element.settings.styles.borderColor}`;

        this.style = {
            '--border': border ?? 'none',
            '--border-radius': this.element.settings.styles.borderRadius ?? '0px',
            '--hover-background-color': buttonStyles.hoverBackgroundColor ?? buttonStyles.backgroundColor ?? 'transparent',
            '--hover-color': buttonStyles.hoverColor ?? 'inherit',
            '--pressed-color': buttonStyles.pressedColor ?? 'inherit',
            '--pressed-background-color': buttonStyles.pressedBackgroundColor ?? buttonStyles.backgroundColor ?? 'transparent',
            '--background-color': buttonStyles.backgroundColor ?? 'transparent',
            '--image-to-text-position': 'up',
        };
    }

    private getWysiwygAligmentClasses(component: ContentItemTree): string {
        const classes: string[] = [];
        if (component.settings) {
            if (component.settings.general.typetext) classes.push(component.settings.general.typetext);
            if (component.settings.styles.textPositionVertical) classes.push(`vertical-${component.settings.styles.textPositionVertical}`);
        }
        return classes.join(' ');
    }
}
